import { isValidJoinCode, WORDS_PER_JOIN_CODE } from "@proef/domain";
import { z } from "zod";

/** A join code is short and typeable, not a UUID: read aloud at a table
 * (dohhh's lobby pattern, docs/product/prd.md 4.3, packages/domain's
 * joinCode.ts). Six common four-letter words, dash-separated -- easier to
 * say and spell across a table than six random letters/digits. Lives apart
 * from flight.ts so tasting.ts can reference a flight without an import cycle. */
export const FlightJoinCode = z
  .string()
  .refine(
    isValidJoinCode,
    `join code must be ${WORDS_PER_JOIN_CODE} dictionary words separated by "-" (e.g. acid-acre-aged-airy-aloe-amid)`,
  );
export type FlightJoinCode = z.infer<typeof FlightJoinCode>;
